import * as React from 'react';
import * as _ from 'lodash';
import ReactSelect from 'react-select';
import InputErrorClass from 'src/components/Shared/InputErrorClass';
import { NATIONALITIES } from 'src/globals';
import { DestinationsAutocomplete } from 'lesamis-react-components';
import TagsAutocomplete from 'src/containers/Shared/TagsAutocomplete';

const nights = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
  17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 100,
].map((i: any) => ({ value: i, label: i })).concat([{ value: 1001, label: '1001 ❤' }]);

export default class Packages extends React.Component<any, any> {
  public render() {
    const { values, handleChange, errors, setFieldValue } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Idioma</label>
              <select
                className={InputErrorClass({ errors, name: 'data.locale' })}
                name="data.locale"
                onChange={handleChange}
                value={values.data.locale}
              >
                <option value="es">Español</option>
                <option value="en">Ingles</option>
              </select>
              {errors['data.locale'] && <p className="invalid-feedback">{errors['data.locale']}</p>}
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Nacionalidad pax.</label>
              <select
                className={InputErrorClass({ errors, name: 'data.nationality' })}
                name="data.nationality"
                onChange={handleChange}
                value={values.data.nationality}
              >
                {
                  NATIONALITIES.map((nac: any, i: number) => {
                    return <option key={i} value={nac.code}>{nac.name}</option>
                  })
                }
              </select>
              {errors['data.nationality'] && <p className="invalid-feedback">{errors['data.nationality']}</p>}
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Moneda</label>
              <select
                className={InputErrorClass({ errors, name: 'data.currency' })}
                name="data.currency"
                onChange={handleChange}
                value={values.data.currency}
              >
                <option value="ARS">ARS</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
              </select>
              {errors['data.currency'] && <p className="invalid-feedback">{errors['data.currency']}</p>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Dias</label>
              <ReactSelect
                defaultValue={Array.from(values.data.days).map((d: string) => ({ label: d, value: d }))}
                isMulti
                name="data.days"
                options={nights}
                onChange={(selected: string[]) => setFieldValue('data.days', (selected || []).map((s: any) => s.value))}
                closeMenuOnSelect={false}
              />
              {errors['data.days'] && <p className="invalid-feedback">{errors['data.days']}</p>}
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Noches</label>
              <ReactSelect
                defaultValue={Array.from(values.data.nights).map((d: string) => ({ label: d, value: d }))}
                isMulti
                name="data.nights"
                options={nights}
                onChange={(selected: string[]) => setFieldValue('data.nights', (selected || []).map((s: any) => s.value))}
                closeMenuOnSelect={false}
              />
              {errors['data.nights'] && <p className="invalid-feedback">{errors['data.nights']}</p>}
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Resultados</label>
              <input
                className={InputErrorClass({ errors, name: 'data.pageSize' })}
                type="number"
                min="1"
                name="data.pageSize"
                onChange={handleChange}
                value={values.data.pageSize}
              />
              {errors['data.pageSize'] && <p className="invalid-feedback">{errors['data.pageSize']}</p>}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label>Saliendo desde</label>
          <DestinationsAutocomplete
            defaultSelected={values.data.departure ? [values.data.departure]: []}
            settings={{ endpoint: 'autocompleteCities', emptyOnSelect: false }}
            onSelected={(selected: any) => {
              setFieldValue('data.departure', _.pick(selected, 'id', 'name', 'code'));
            }}
          />
          {errors['data.departure'] && <p className="invalid-feedback">{errors['data.departure']}</p>}
        </div>
        <div className="form-group">
          <label>Destinos</label>
          <DestinationsAutocomplete
            defaultSelected={values.data.packageDestinations}
            settings={{
              endpoint: 'autocompleteCities',
              emptyOnSelect: false,
              multiple: true,
            }}
            onSelected={(selected: any) => {
              setFieldValue('data.packageDestinations',
                selected.map((s: any) => _.pick(s, ['id', 'name', 'code']))
              );
            }}
            renderOption={(option: any, i: number) => {
              return (<div key={i}>{option.name}, {option.Country.name}</div>);
            }}
          />
          {errors['data.packageDestinations'] && <p className="invalid-feedback">{errors['data.packageDestinations']}</p>}
        </div>
        <div className="form-group">
          <label>Paises</label>
          <DestinationsAutocomplete
            defaultSelected={values.data.packageCountries}
            settings={{
              endpoint: 'autocompleteCountries',
              emptyOnSelect: false,
              multiple: true,
            }}
            onSelected={(selected: any) => {
              setFieldValue('data.packageCountries',
                selected.map((s: any) => _.pick(s, ['id', 'name', 'code']))
              );
            }}
            renderOption={(option: any, i: number) => {
              return (<div key={i}>{option.name}</div>);
            }}
          />
          {errors['data.packageCountries'] && <p className="invalid-feedback">{errors['data.packageCountries']}</p>}
        </div>
        <div className="form-group">
          <label>Regiones</label>
          <DestinationsAutocomplete
            defaultSelected={values.data.packageRegions}
            settings={{
              endpoint: 'autocompleteRegions',
              emptyOnSelect: false,
              multiple: true,
            }}
            onSelected={(selected: any) => {
              setFieldValue('data.packageRegions',
                selected.map((s: any) => _.pick(s, ['id', 'name', 'code']))
              );
            }}
            renderOption={(option: any, i: number) => {
              return (<div key={i}>{option.name}</div>);
            }}
          />
          {errors['data.packageRegions'] && <p className="invalid-feedback">{errors['data.packageRegions']}</p>}
        </div>
        <div className="form-group">
          <label>Tags</label>
          <TagsAutocomplete
            defaultSelected={values.data.tags}
            settings={{ emptyOnSelect: false, multiple: true }}
            onSelected={(selected: any) => {
              setFieldValue('data.tags', selected);
            }}
          />
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Coincidencia de tags</label>
              <select
                className={InputErrorClass({ errors, name: 'data.packagesOptions.tags' })}
                name="data.packagesOptions.tags"
                onChange={handleChange}
                value={values.data.packagesOptions.tags}
              >
                <option value="in">Al menos una coincidencia</option>
                <option value="all">Todos deben coincidir</option>
              </select>
              {errors['data.packagesOptions.tags'] && <p className="invalid-feedback">{errors['data.packagesOptions.tags']}</p>}
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Coincidencia de destinos</label>
              <select
                className={InputErrorClass({ errors, name: 'data.packagesOptions.destinations' })}
                name="data.packagesOptions.destinations"
                onChange={handleChange}
                value={values.data.packagesOptions.destinations}
              >
                <option value="in">Al menos una coincidencia</option>
                <option value="all">Todos deben coincidir</option>
              </select>
              {errors['data.packagesOptions.destinations'] && <p className="invalid-feedback">{errors['data.packagesOptions.destinations']}</p>}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label>Tipo</label>
          <select
            className={InputErrorClass({ errors, name: 'data.type' })}
            name="data.type"
            onChange={handleChange}
            value={values.data.type}
          >
            <option value="">Indistinto</option>
            <option value="1">Opcion 1</option>
            <option value="2">Opcion 2</option>
            <option value="3">Opcion 3</option>
          </select>
          {errors['data.type'] && <p className="invalid-feedback">{errors['data.type']}</p>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Packages.tsx